<div class="row header-section mt-5">

  <div class="col-lg-6 col-md-9 col-sm-9 col-sm-9 col-xs-12">
    <h4>
      Wave Branch Configuration
    </h4>
  </div>

  <div class="col-lg-6 col-md-3 col-sm-3 col-xs-12 flex-right">
    @if (defaults.isMersyAdminUser  || defaults.isMersyAdminSafetySystemExcellence) {
      <div class="OrangeButton" style="margin-right: 50px; display:flex;">
        @if (!isRemoveAssignmentEnabled) {
          <button mat-raised-button (click)="openAssignBranchPopup()"
            title="Assign new branches" class="btn btn-sm button-color-fix">
            Add Branch <mat-icon class="add-button icon-color-fix">add_box</mat-icon>
          </button>
        }
        @if (!isRemoveAssignmentEnabled) {
          <button mat-raised-button (click)="enableRemoveAssignmentMode()"
            title="Remove assigned branches" class="btn btn-sm button-color-fix">
            Unassign <mat-icon class="add-button icon-color-fix">remove_circle</mat-icon>
          </button>
        }
        @if (isRemoveAssignmentEnabled) {
          <button mat-raised-button (click)="enableRemoveAssignmentMode()"
            title="Close unassignment mode" class="btn btn-sm button-color-fix">
            Close <mat-icon class="add-button icon-color-fix">close</mat-icon>
          </button>
        }
      </div>
    }
  </div>
</div>

<div class="">
  <table mat-table #itemsList
    [dataSource]="dataSource"
    multiTemplateDataRows
    class="mat-elevation-z8 mat-table-custom" id="osh-wavebranchconfiguration">

    <ng-container matColumnDef="Checkbox">
      <th mat-header-cell *matHeaderCellDef>
        @if (isRemoveAssignmentEnabled) {
          <mat-checkbox class="select-all-checkbox"
            matTooltip="Select All"
            (click)="$event.stopPropagation();"
            (keydown)="$event.stopPropagation();"
            [checked]="isAllSelected()"
            [indeterminate]="isPartiallySelected()"
            (change)="controlAssignedItem($event.checked)">
            Select All
          </mat-checkbox>
        }
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="">
          @if (isRemoveAssignmentEnabled) {
            <mat-checkbox (click)="$event.stopPropagation();" (keydown)="$event.stopPropagation();"
              [checked]="removeBranchesList.includes(element.mgmtId)"
              (change)="controlAssignedItem($event.checked, element)">
            </mat-checkbox>
          }
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="mgmtId">
      <th mat-header-cell *matHeaderCellDef> Branch Id </th>
      <td mat-cell *matCellDef="let element">
        <p [innerHTML]="element.mgmtId"></p>
      </td>
    </ng-container>

    <ng-container matColumnDef="mgmtName">
      <th mat-header-cell *matHeaderCellDef> Branch Name </th>
      <td mat-cell *matCellDef="let element">
        <p [innerHTML]="element.mgmtName"></p>
      </td>
    </ng-container>

    <tr mat-header-row class="tableheader" *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let element; let i = dataIndex; columns: columnsToDisplay;"
      class="item">
    </tr>
  </table>
</div>

@if (isRemoveAssignmentEnabled && defaults.isMersyAdminSafetySystemExcellence) {
  <div class="stickybottompanel" style="margin-bottom:10px;">
    @if (removeBranchesList.length > 0) {
      <div class="col-lg-6" style="width:50%">
        Total selected branches : {{removeBranchesList.length}}
      </div>
    }
    @if (removeBranchesList.length <= 0) {
      <div class="col-lg-6" style="width:50%">
        Please select at least one Branch
      </div>
    }
    @if (removeBranchesList.length > 0) {
      <button class="btn btn-realease btn-sm pull-right button-margin" (click)="confirmRemoveAssignedBranches()">
        Confirm
      </button>
    }
  </div>
}

